import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe(
{
  name: 'HtmlSeguro'
})

export class HtmlSeguroPipe implements PipeTransform
{
  constructor(private sanitized: DomSanitizer)
  {
  }

  transform(contenidoHtml: string): SafeHtml
  {
    return this.sanitized.bypassSecurityTrustHtml(contenidoHtml);
  }
}
